/*
    The OP Launch Dashboard's surviving tiles (MPN-2230), one per chart the old page drew,
    by the chart id the server answers to. `sort` is a table tile's default sort; `money`
    puts dollars on the values. The page lays them out by section; this is only the catalogue.
*/

export type TileKind = "table" | "area" | "line" | "pie" | "bar" | "donut" | "rings";

export interface TileSpec {
    id: string;
    kind: TileKind;
    /** The widget's header. A table tile may also carry its own title from the server. */
    title: string;
    sort?: string;
    money?: boolean;
    yTitle?: string;
    /** A pie whose slices mean something by colour (overspent is red): keep the server's colours instead of the ladder. */
    ownColors?: boolean;
}

export const TILES = {
    impactMetrics: { id: "impact-metrics", kind: "table", title: "Launch Impact Metrics" },
    impactTrendline: { id: "impact-trendline", kind: "line", title: "Constituent-Level Conversions", yTitle: "Conversions" },
    conversionJourneys: { id: "conversion-journeys", kind: "table", title: "Conversion Journeys in Time" },
    launchDates: { id: "events-dates", kind: "donut", title: "Launch Dates" },
    performanceMetrics: { id: "performance-metrics", kind: "table", title: "Performance Metrics", sort: "total" },
    notes: { id: "notes", kind: "table", title: "Notes", sort: "-datetime_posted" },
    keyDates: { id: "keydates-summary", kind: "table", title: "Key Dates", sort: "date" },
    served: { id: "constituents-served", kind: "rings", title: "People Served Since Start" },
    budgetSummary: { id: "budget-summary", kind: "pie", title: "Budget Summary", money: true, ownColors: true },
    spendByPlatform: { id: "spend-by-publisher-platform", kind: "area", title: "Spend by Publisher Platform Over Time", money: true, yTitle: "Spend" },
    spendSharePlatform: { id: "spend-distribution-by-publisher-platform", kind: "pie", title: "Spend by Publisher Platform", money: true },
    impressionsSharePlatform: { id: "impressions-distribution-by-publisher-platform", kind: "pie", title: "Impressions by Publisher Platform" },
    spendByVector: { id: "spend-by-vector", kind: "area", title: "Spend by Vector Over Time", money: true, yTitle: "Spend" },
    spendShareVector: { id: "spend-distribution-by-vector", kind: "pie", title: "Spend by Vector", money: true },
    impressionsShareVector: { id: "impressions-distribution-by-vector", kind: "bar", title: "Impressions by Vector" },
    impressionsByPlatform: { id: "impressions-by-publisher-platform", kind: "area", title: "Impressions by Publisher Platform Over Time", yTitle: "Impressions" },
    impressionsPerConstituent: { id: "impressions-per-constituent-by-vector", kind: "area", title: "Impressions per Constituent by Vector", yTitle: "Impressions" },
    impressionsShareObjective: { id: "impressions-distribution-by-objective", kind: "bar", title: "Impressions by Objective" },
} satisfies Record<string, TileSpec>;

/** Every tile, for anything that wants to iterate them. */
export const ALL_TILES: TileSpec[] = Object.values(TILES);
